import { BearerMfaAuthenticationStrategy } from '@reckon-web/rest-api-client';

export const PortalRestAuthenticationStrategy = new BearerMfaAuthenticationStrategy(
  {
    bearerTokenKey: 'authorizationtoken',
  }
);
